const ENTER = 'animate-in ease-out fill-mode-both';

export const FADE_IN = `${ENTER} fade-in [animation-duration:900ms]`;
// tw-animate-css reads slide-in-from-bottom-5 as 5% of the element's height, not 5 spacing steps
export const FADE_IN_UP = `${ENTER} fade-in slide-in-from-bottom-[1.25rem] [animation-duration:600ms]`;

// Inline style, not a delay utility class: Tailwind's scanner never sees a computed class name.
export function fadeInDelay(step: number) {
    return { animationDelay: `${300 + step * 200}ms` };
}
